/** Property parameter whose value is the Product's `ProductLine.key`. */
export const PRODUCT_LINE_PARAMETER_ID = "633afb41b2e8cb6b28aa8490";

/** How long a notification stays on screen, in ms. */
export const INFO_TIMEOUT = 5000;

/**
 * Where the taxonomy feature is mounted in the console router (features/taxonomy/index.tsx).
 * It once ran standalone under `basename: "/taxonomy"`; as a console route there is no
 * basename, so a bare "/BimClasses" would leave the feature.
 */
export const TAXONOMY_BASE = "/taxonomy";

/**
 * The document-exports service: Calculations-template admin API (`/api`) and export
 * generation. Hard-coded like the GraphQL gateway URL in ApolloProviderWithAuthToken;
 * both console hosts talk to production.
 */
export const DOCUMENT_EXPORTS_URL = "https://document-exports.bimproject.cloud";
